// extracted by mini-css-extract-plugin
module.exports = {"overlay":"AffordableCarsCard_overlay__JMvFR","slotMachine":"AffordableCarsCard_slotMachine__ZYkVX","fadeIn":"AffordableCarsCard_fadeIn__Ymups"};